export const sanitizeUnenrollmentSetting = revision => {
  if (revision.flow.classicEnrollmentSettings && revision.flow.classicEnrollmentSettings.unenrollmentSetting === null) {
    return Object.assign({}, revision, {
      flow: Object.assign({}, revision.flow, {
        classicEnrollmentSettings: Object.assign({}, revision.flow.classicEnrollmentSettings, {
          // @ts-expect-error type is required but is returned from the BE without type
          unenrollmentSetting: {
            excludedWorkflows: []
          }
        })
      })
    });
  }
  return revision;
};